<template>
  <a-card :bordered="false" :bodyStyle="{padding:'20px'}" :headStyle="{borderBottom:'0px',paddingLeft:'20px'}">
    <a-row slot="title">
      <a-col :span="8">
        <span class="card-title">轮播图设置</span>
        <a-tooltip placement="right">
          <template slot="title">
            <span>1.最多展示6条进行中的内容，超过6条时仅显示排序前6条。2.按住鼠标左键可拖动排序</span>
          </template>
          <a-icon type="info-circle"/>
        </a-tooltip>
      </a-col>
      <a-col :span="8" :offset="8" style="text-align:right;">
        <a-button type="primary" @click="handleContent(0)">添加新内容</a-button>
      </a-col>
    </a-row>
    <custom-paging-dragging-list
      ref="table"
      rowKey="modularDetailId"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
      @draggable="onDraggable"
    >
      <div slot="indexSlots" slot-scope="data">{{ data.index + 1 }}</div>
      <template slot="contentSlots" slot-scope="data">
        <span>{{ data.record.modularContentType|getModularContentName }}</span>
      </template>
      <div class="image-table" slot="imageSlots" slot-scope="data">
        <CustomImage width="120" :imageUrl="data.record.modularDetailImg"></CustomImage>
      </div>
      <div slot="action" slot-scope="data">
        <a @click="handleContent(data.record.modularDetailId)">编辑</a>
        <a-divider type="vertical"/>
        <a-popconfirm
          title="你确定要删除这行内容吗?"
          @confirm="deleteEvent(data.record)">
          <a-icon slot="icon" type="close-circle" style="color: red"/>
          <a>删除</a>
        </a-popconfirm>
      </div>
    </custom-paging-dragging-list>
  </a-card>
</template>

<script>
import CustomPagingDraggingList from '@/customComponents/CustomPagingDraggingList/CustomPagingDraggingList'

export default {
  name: 'SlideShowComponents',
  components: {
    CustomPagingDraggingList
  },
  data() {
    return {
      columns: [
        {
          title: '排序',
          dataIndex: 'index',
          scopedSlots: { customRender: 'indexSlots' },
          width: '70px'
        },
        {
          title: '图片',
          dataIndex: 'modularDetailImg',
          slots: { title: 'customTitle' },
          width: '150px',
          scopedSlots: { customRender: 'imageSlots' }
        },
        {
          title: '标题',
          width: '28%',
          dataIndex: 'modularDetailTitle'
        },
        {
          title: '内容类型',
          dataIndex: 'modularContentType',
          scopedSlots: { customRender: 'contentSlots' }
        },
        {
          title: '投放时间',
          dataIndex: 'modularActiveTime'
        },
        {
          title: '状态',
          dataIndex: 'modularActiveStatus',
          width: '90px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '90px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      loadPromise: params => this.getModularListPromise(params),
      queryParams: {
        homeModularId: 0,
        homeModularDetailStatus: 0
      }
    }
  },
  mounted() {
    this.getSlideType()
  },
  activated() {
    this.$refs.table.refresh(true)
  },
  methods: {
    getSlideType() {
      let url = '/pc/v2/circle-picture/init'
      this.getHttpServices().getUserService().post(url)
        .then(res => {
          this.queryParams.homeModularId = res.modularDetailId
          this.$refs.table.refresh(true)
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    handleContent(id) {
      let params = {
        homeModularId: this.queryParams.homeModularId
      }
      if (id) {
        params.modularDetailId = id
      }
      this.openNewPage('AddSlideShow', params)
    },
    // 删除
    deleteEvent(item) {
      let params = {}
      params.modularDetailId = item.modularDetailId
      this.getHttpServices().getUserService().post('homepage/recommend/del/modularDetail', params)
        .then(res => {
          this.$refs.table.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 拖拽排序功能
    onDraggable(params) {
      let idList = new Array
      idList = params.dataList.map((item) => {
        return item.modularDetailId
      })
      this.getHttpServices().getUserService().post('homepage/recommend/update/updateBatchModularDetailSerial', {
        pageNum: params.pageNo,
        pageSize: params.pageSize,
        idList: idList
      }).then(res => {
        this.$message.success('排序成功')
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getModularListPromise(params) {
      if (params.homeModularId) {
        return this.getHttpServices().getUserService().post('homepage/recommend/get/modularDetailList', params)
      } else {
        return new Promise(resolve => {
          const result = {
            pageSize: 1,
            totalCount: 0,
            totalPage: 1,
            data: []
          }
          resolve(result)
        })
      }
    }
  }
}
</script>

<style lang="less">

.ant-tooltip-inner {
  width: 555px;
}
</style>